import { gql } from 'apollo-angular';
import { dashboardRoleFragment } from './dashboard-role.fragments';

export const DashboardRoleQuery = gql`
  query DashboardRoleQuery($id: ID!) {
    node(id: $id) {
      ... on DashboardRole {
        ...DashboardRoleFragment
      }
    }
  }
  ${dashboardRoleFragment}
`;
